import { render, staticRenderFns } from "./MotivationsRegistry.vue?vue&type=template&id=3dc5abba&scoped=true&"
import script from "./MotivationsRegistry.vue?vue&type=script&lang=js&"
export * from "./MotivationsRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc5abba",
  null
  
)

export default component.exports